import { Button, TableCell } from '@material-ui/core'

import EditIcon from '@material-ui/icons/Edit'
import moment from 'moment'
import { connect, useSelector } from 'react-redux'
import React from 'react'
import { ButtonGridCol } from '../../components'
import { getDevice } from '../../state/DeviceById/selectors'
import { editUserStart } from '../../state/SystemCache/actions'
import { getUser } from '../../state/UserById/selectors'
import { Device, State, User } from '../../types'
import { categories } from '../../utils'
import { decrypt } from '../../utils/encrypt'

type Props = {
  user: User | undefined
  userId: string
  handleEditUser: () => void
}
const format = (ts: number) => moment(ts * 1000).format('YYYY/MM/DD')
const dformat = (dstr?: string) => dstr?.replace(/-/g, '/') || '---'

function UserListItem(props: Props) {
  const { user } = props

  const devices = useSelector<State, Device[]>((state) => {
    return Object.keys(user?.deviceIds || {}).map((id) => getDevice(state, id))
  })

  if (!user) {
    return (
      <tr>
        <TableCell>loading {props.userId}</TableCell>
      </tr>
    )
  }
  return (
    <tr>
      <TableCell>{user.company}</TableCell>
      <TableCell>
        <div>{user.email}</div>
        <div>{decrypt(user.managedPassword)}</div>
      </TableCell>
      <TableCell>
        <div>{user.label}</div>
        <div>({user.nid})</div>
      </TableCell>
      <TableCell>
        <div style={{ display: 'grid' }}>
          {devices.map(
            (d) =>
              d && (
                <span key={d.id}>
                  {d.id}({categories[d.category][0]})
                </span>
              ),
          )}
        </div>
      </TableCell>
      <TableCell>{user.allowIntegration ? '許可' : ''}</TableCell>
      <TableCell>{user.allowDownload ? '許可' : ''}</TableCell>
      <TableCell>{dformat(user.contactStartDate)} </TableCell>
      <TableCell>{dformat(user.contactEndDate)}</TableCell>
      <TableCell className="visible-wide">{format(user.createdAt)}</TableCell>
      <TableCell className="visible-wide">{format(user.updatedAt)}</TableCell>
      <TableCell>{user.memo}</TableCell>
      <TableCell>
        <ButtonGridCol>
          <Button style={{ margin: 0 }} onClick={props.handleEditUser}>
            <EditIcon />
            変更
          </Button>
        </ButtonGridCol>
      </TableCell>
    </tr>
  )
}

type OProps = {
  userId: string
}
type DProps = {
  editUserStart: (id: string) => void
}
type SProps = {
  user: User | undefined
}

const conn = connect<SProps, DProps, OProps, Props, State>(
  (state, op) => ({
    user: getUser(state, op.userId),
  }),
  { editUserStart },
  (sp, dp, op) => ({
    ...sp,
    ...op,
    handleEditUser: () => dp.editUserStart(op.userId),
  }),
)
const UserListItemContainer = conn(UserListItem)

export default UserListItemContainer
